
import { Component, Prop, Vue } from 'vue-property-decorator';
import { Moment } from 'moment-timezone';
import { AppointmentSlot, Appointment } from '@/types/Appointment';

import { library } from '@fortawesome/fontawesome-svg-core';
import { faUser, faChalkboardTeacher } from '@fortawesome/free-solid-svg-icons';

library.add(faUser, faChalkboardTeacher);

@Component
export default class AppointmentCell extends Vue {
	@Prop({ required: true }) admin!: boolean;
	@Prop({ required: true }) time!: Moment;
	@Prop({ required: true }) appointmentSlot!: AppointmentSlot;

	get classes() {
		if (this.admin) {
			const takenByStudent = this.appointmentSlot.filledByStudent;
			const takenByStaff = this.appointmentSlot.filledByStaff;
			const takenByMe =
				takenByStaff &&
				(this.appointmentSlot as Appointment).staffEmail ===
					this.$root.$data.userInfo.email;
			return {
				'is-danger': takenByStudent && !takenByStaff,
				'is-warning': takenByStudent && takenByStaff && !takenByMe,
				'is-success': !takenByStudent && takenByMe,
				'is-primary': takenByStudent && takenByMe,
				past:
					this.appointmentSlot.scheduledTime
						.clone()
						.add(this.appointmentSlot.duration, 'minutes') < this.time,
			};
		}
		const filled = this.appointmentSlot.filledByStudent;
		const myAppointment =
			filled &&
			this.$root.$data.userInfo.email !== undefined &&
			(this.appointmentSlot as Appointment).studentEmail ===
				this.$root.$data.userInfo.email;
		return {
			'is-success': !filled,
			'is-danger': filled && !myAppointment,
			'is-primary': myAppointment,
			'is-light': this.appointmentSlot.scheduledTime < this.time,
		};
	}

	get cellWidth() {
		return this.admin ? 6 : 1.5;
	}

	get cellHeight() {
		return this.admin ? 4 : 1.5;
	}
}
